/**
 * Created by Mateusz Lipowski on 08.11.2016.
 */

namespace Action.ContextMenu {
    export class MarkerPhotos extends Action.UserActionBase {
        public constructor(event: Action.UserActionEvent) {
            super(event);
        }

        public execute(): void {
            let node: Entity.Map.Marker.Node.Node = this.event.target as Entity.Map.Marker.Node.Node;
            let photosWindow: Entity.View.Window.PhotosWindow = this.app.service.windowContainer.createWindow(Control.WindowClass.PHOTOS_WINDOW) as Entity.View.Window.PhotosWindow;
            photosWindow.showForNode(node);
        }
    }
}
